import React, { useState, useEffect, useContext } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import { FaRegEdit } from "react-icons/fa";
import AddEditQBAdmin from "./AddEditQBAdmin";
import { HiMiniPlusSmall } from "react-icons/hi2";
import { FaRegEye } from "react-icons/fa";
import { LoadContext } from "../../ReusableComponents/LoadingContex";
import { useSelector } from "react-redux";
import notify from "../../ReusableComponents/ToastifyAlerts";
import InternetChecking from "../../Student/Reusablecomponents/Network";
const QBAdminList = () => {
  const { SetLoad } = useContext(LoadContext);
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [Uservalues, setUservalues] = useState([]);
  const [OpenForm, CloseForm] = useState(false);
  const [EditAdmin, SetEditAdmin] = useState();
  const [visiblePasswords, setVisiblePasswords] = useState({});
  const [DisplayUserStatus, SetDisplayUserStatus] = useState(1);
  const GetAdminList = async () => {
    SetLoad(true);
    try {
      const res = await axiosInstance.get(`/NCLAdmin/Users?IsActive=${DisplayUserStatus}`);
      setUservalues(res.data);
      SetLoad(false);
    } catch (err) {
      return [];
    }
  };
  useEffect(() => { GetAdminList(); }, [DisplayUserStatus]);

  const AddAdminForm = () => {
    CloseForm(!OpenForm);
    SetEditAdmin();
  };
  const handleEdit = (SingleRow) => {
    CloseForm(!OpenForm);
    SetEditAdmin(SingleRow);
  };
  const Columns = [
    { name: "First Name", selector: "firstName", sortable: true },
    { name: "Last Name", selector: "lastName", sortable: false },
    { name: "LoginId", selector: "loginId", sortable: true },
    { name: "Subjects", selector: "subjectName", sortable: true },
    {
      name: "Password",
      cell: (row) => (
        <div className="dflex h-100 gap-1" style={{ justifyContent: "center" }}>
          {visiblePasswords[row.userId] ? (<span>{row.password}</span>) : (<span style={{ fontsize: "10px" }}>*****</span>)}
          <FaRegEye className="CPointer" title={visiblePasswords[row.userId] ? "Hide Password" : "Show Password"}
            onClick={() => setVisiblePasswords((prev) => ({ ...prev, [row.userId]: !prev[row.userId], }))} />
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
    {
      name: "Action",
      cell: (row) => (<div className="dflex gap-2 JCCenter" >
      {DisplayUserStatus== 1 && <>  <FaRegEdit title="Edit School Details" className="CPointer" style={{ color: "#624DE3" }}
          size={18} onClick={() => { handleEdit(row); }}
        /> |</> }<span className="LinkStyles" onClick={() => Conformation(row)} title="Edit User details"> {!row.isActive ? "Make Active" : "Make Inactive"} </span>
      </div>
      ),
    },
  ];

  const Conformation = (Row) => {
    if (window.confirm(
      `Are you sure you want to ${!Row.isActive ? "activate" : "Inactivate"} the User : ${Row.firstName} ${Row.lastName} `
    )
    ) {
      HandleUserStatus(Row.userId);
    }
  };

  const HandleUserStatus = async (UId) => {
    SetLoad(true);
    try {
      const res = await axiosInstance.post(`/NCLAdmin/UpdateQBAdminStatus?UserID=${UId}&IsActive=${DisplayUserStatus == 1 ? 0 : 1}&ModifiedBy=${items.userId}`);
      if (res.data > 0) {
        notify(`User ${DisplayUserStatus == 1 ? "inactivated" : "activated"}  successfully`, "success");
        GetAdminList();
      } else {
        notify("User Status not updated - Please try again", "error");
      }
    }
    catch (err) { notify("User Status not updated - Please try again", "error"); }
    finally { SetLoad(false); }
  }
  return (
    <>
      <div className="TeacherBgImage">
        <InternetChecking />
        <div className="dflex alignitems JSBetween" style={{ position: "relative" }} >
          <div></div>
          <div className="MainHeading" style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", }} >
            QB Admin Users  </div>
          <div className="dflex alignitems gap-3">
            <div className="dflex gap-3">
              {[1, 0].map((item) => (
                <span className="dflex alignitems  gap-1" style={{ color: item === 0 && "#878997" }}><input
                  type="radio" name="ActiveStatus" value={item} defaultChecked={DisplayUserStatus === item}
                  onChange={(e) => { SetDisplayUserStatus(e.target.value); }} />
                  {item === 1 ? "Active" : "Inactive"} </span>))}
            </div>
          {DisplayUserStatus == 1 &&   <button className="Buttons AddButton" onClick={AddAdminForm}> <HiMiniPlusSmall /> Add </button>}
          </div>
        </div>
        <DataTable data={Uservalues} columns={Columns} className="NCLDataTable Card mt-3"
          Dropdownvalues={["10", "25", "50", "100"]} ShowPagination={true} ShowPagecount={true} />
      </div>
      {OpenForm && (<div className="Model-Open"> <AddEditQBAdmin Cancle={CloseForm} EditDetails={EditAdmin} GetList={GetAdminList} /> </div>)}
    </>
  );
};
export default QBAdminList;
